import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';

const Datenschutz = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-slate-50 py-24">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        {/* Back Button */}
        <Button
          variant="ghost"
          onClick={onBack}
          className="mb-8 text-teal-600 hover:text-teal-700 hover:bg-teal-50"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Zurück zur Startseite
        </Button>

        <div className="bg-white rounded-2xl shadow-lg p-8 lg:p-12">
          <h1 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-8">
            Datenschutzerklärung
          </h1>

          <div className="prose prose-slate max-w-none space-y-6 text-slate-700">
            <p>
              Diese Datenschutzerklärung klärt Sie über die Art, den Umfang und Zweck der Verarbeitung 
              von personenbezogenen Daten (nachfolgend kurz „Daten") innerhalb unseres Onlineangebotes 
              und der mit ihm verbundenen Webseiten, Funktionen und Inhalte sowie externen Onlinepräsenzen, 
              wie z.B. unser Social Media Profile auf (nachfolgend gemeinsam bezeichnet als „Onlineangebot"). 
              Im Hinblick auf die verwendeten Begrifflichkeiten, wie z.B. „Verarbeitung" oder „Verantwortlicher" 
              verweisen wir auf die Definitionen im Art. 4 der Datenschutzgrundverordnung (DSGVO).
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Verantwortlicher</h2>
            <p>
              Bärbel Paul<br />
              ADMIN Hausverwaltung<br />
              Domblick 24 c<br />
              39175 Gerwisch<br />
              Deutschland<br /><br />
              E-Mailadresse: baerbel.paul@admin-hausverwaltung.de<br />
              Geschäftsführer/Inhaber: Bärbel Paul
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Arten der verarbeiteten Daten</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Bestandsdaten (z.B., Namen, Adressen).</li>
              <li>Kontaktdaten (z.B., E-Mail, Telefonnummern).</li>
              <li>Inhaltsdaten (z.B., Texteingaben, Fotografien, Videos).</li>
              <li>Nutzungsdaten (z.B., besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten).</li>
              <li>Meta-/Kommunikationsdaten (z.B., Geräte-Informationen, IP-Adressen).</li>
            </ul>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Kategorien betroffener Personen</h2>
            <p>
              Besucher und Nutzer des Onlineangebotes (Nachfolgend bezeichnen wir die betroffenen 
              Personen zusammenfassend auch als „Nutzer").
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Zweck der Verarbeitung</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Zurverfügungstellung des Onlineangebotes, seiner Funktionen und Inhalte.</li>
              <li>Beantwortung von Kontaktanfragen und Kommunikation mit Nutzern.</li>
              <li>Sicherheitsmaßnahmen.</li>
              <li>Reichweitenmessung/Marketing</li>
            </ul>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Maßgebliche Rechtsgrundlagen</h2>
            <p>
              Nach Maßgabe des Art. 13 DSGVO teilen wir Ihnen die Rechtsgrundlagen unserer 
              Datenverarbeitungen mit. Sofern die Rechtsgrundlage in der Datenschutzerklärung 
              nicht genannt wird, gilt Folgendes: Die Rechtsgrundlage für die Einholung von 
              Einwilligungen ist Art. 6 Abs. 1 lit. a und Art. 7 DSGVO, die Rechtsgrundlage 
              für die Verarbeitung zur Erfüllung unserer Leistungen und Durchführung 
              vertraglicher Maßnahmen sowie Beantwortung von Anfragen ist Art. 6 Abs. 1 lit. b DSGVO, 
              die Rechtsgrundlage für die Verarbeitung zur Erfüllung unserer rechtlichen 
              Verpflichtungen ist Art. 6 Abs. 1 lit. c DSGVO, und die Rechtsgrundlage für 
              die Verarbeitung zur Wahrung unserer berechtigten Interessen ist Art. 6 Abs. 1 lit. f DSGVO.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Sicherheitsmaßnahmen</h2>
            <p>
              Wir treffen nach Maßgabe des Art. 32 DSGVO unter Berücksichtigung des Stands der Technik, 
              der Implementierungskosten und der Art, des Umfangs, der Umstände und der Zwecke der 
              Verarbeitung sowie der unterschiedlichen Eintrittswahrscheinlichkeit und Schwere des 
              Risikos für die Rechte und Freiheiten natürlicher Personen, geeignete technische und 
              organisatorische Maßnahmen, um ein dem Risiko angemessenes Schutzniveau zu gewährleisten.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Rechte der betroffenen Personen</h2>
            <p>
              Sie haben das Recht, eine Bestätigung darüber zu verlangen, ob betreffende Daten verarbeitet 
              werden und auf Auskunft über diese Daten sowie auf weitere Informationen und Kopie der 
              Daten entsprechend Art. 15 DSGVO.
            </p>
            <p>
              Sie haben entsprechend Art. 16 DSGVO das Recht, die Vervollständigung der Sie betreffenden 
              Daten oder die Berichtigung der Sie betreffenden unrichtigen Daten zu verlangen.
            </p>
            <p>
              Sie haben nach Maßgabe des Art. 17 DSGVO das Recht zu verlangen, dass betreffende Daten 
              unverzüglich gelöscht werden, bzw. alternativ nach Maßgabe des Art. 18 DSGVO eine 
              Einschränkung der Verarbeitung der Daten zu verlangen.
            </p>
            <p>
              Sie haben das Recht zu verlangen, dass die Sie betreffenden Daten, die Sie uns bereitgestellt 
              haben nach Maßgabe des Art. 20 DSGVO zu erhalten und deren Übermittlung an andere 
              Verantwortliche zu fordern.
            </p>
            <p>
              Sie haben ferner gem. Art. 77 DSGVO das Recht, eine Beschwerde bei der zuständigen 
              Aufsichtsbehörde einzureichen.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Widerrufsrecht</h2>
            <p>
              Sie haben das Recht, erteilte Einwilligungen gem. Art. 7 Abs. 3 DSGVO mit Wirkung für 
              die Zukunft zu widerrufen.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Widerspruchsrecht</h2>
            <p>
              Sie können der künftigen Verarbeitung der Sie betreffenden Daten nach Maßgabe des 
              Art. 21 DSGVO jederzeit widersprechen. Der Widerspruch kann insbesondere gegen die 
              Verarbeitung für Zwecke der Direktwerbung erfolgen.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Cookies</h2>
            <p>
              Als „Cookies" werden kleine Dateien bezeichnet, die auf Rechnern der Nutzer gespeichert werden. 
              Innerhalb der Cookies können unterschiedliche Angaben gespeichert werden. Ein Cookie dient 
              primär dazu, die Angaben zu einem Nutzer während oder auch nach seinem Besuch innerhalb eines 
              Onlineangebotes zu speichern.
            </p>
            
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3">Verwendete Cookie-Kategorien:</h3>
            
            <p className="mb-4"><strong>1. Notwendige Cookies (Erforderlich)</strong></p>
            <p className="mb-4">
              Diese Cookies sind für die Grundfunktionen der Website unerlässlich. Sie speichern Ihre 
              Cookie-Einstellungen und ermöglichen die Navigation auf der Website. Diese Cookies können 
              nicht deaktiviert werden.
            </p>
            
            <p className="mb-4"><strong>2. Funktionale Cookies</strong></p>
            <p className="mb-4">
              Diese Cookies ermöglichen erweiterte Funktionen wie die Einbettung von Google Maps zur 
              Anzeige unseres Standorts. Diese Cookies werden nur mit Ihrer Einwilligung gesetzt.
            </p>
            
            <p className="mb-4"><strong>3. Analyse Cookies</strong></p>
            <p className="mb-4">
              Diese Cookies helfen uns zu verstehen, wie Besucher mit der Website interagieren, 
              indem sie Informationen anonym sammeln und melden. Diese Cookies werden nur mit 
              Ihrer Einwilligung gesetzt.
            </p>

            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3">Cookie-Einstellungen ändern</h3>
            <p>
              Sie können Ihre Cookie-Einstellungen jederzeit ändern, indem Sie die gespeicherten 
              Cookies in Ihrem Browser löschen. Bei Ihrem nächsten Besuch wird Ihnen das Cookie-Banner 
              erneut angezeigt.
            </p>
            <p className="mt-4">
              Falls die Nutzer nicht möchten, dass Cookies auf ihrem Rechner gespeichert werden, werden 
              sie gebeten die entsprechende Option in den Systemeinstellungen ihres Browsers zu deaktivieren. 
              Gespeicherte Cookies können in den Systemeinstellungen des Browsers gelöscht werden. Der 
              Ausschluss von Cookies kann zu Funktionseinschränkungen dieses Onlineangebotes führen.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Kontaktaufnahme</h2>
            <p>
              Bei der Kontaktaufnahme mit uns (z.B. per Kontaktformular, E-Mail, Telefon oder via sozialer Medien) 
              werden die Angaben des Nutzers zur Bearbeitung der Kontaktanfrage und deren Abwicklung gem. 
              Art. 6 Abs. 1 lit. b) DSGVO verarbeitet.
            </p>
            <p>
              Wir löschen die Anfragen, sofern diese nicht mehr erforderlich sind. Wir überprüfen die 
              Erforderlichkeit alle zwei Jahre; Ferner gelten die gesetzlichen Archivierungspflichten.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Google Maps</h2>
            <p>
              Wir binden die Landkarten des Dienstes "Google Maps" des Anbieters Google LLC, 
              1600 Amphitheatre Parkway, Mountain View, CA 94043, USA, ein. Zu den verarbeiteten Daten 
              können insbesondere IP-Adressen und Standortdaten der Nutzer gehören, die jedoch nicht ohne 
              deren Einwilligung erhoben werden. Die Daten können in den USA verarbeitet werden. 
              Datenschutzerklärung: https://www.google.com/policies/privacy/
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Löschung von Daten</h2>
            <p>
              Die von uns verarbeiteten Daten werden nach Maßgabe der Art. 17 und 18 DSGVO gelöscht oder 
              in ihrer Verarbeitung eingeschränkt. Sofern nicht im Rahmen dieser Datenschutzerklärung 
              ausdrücklich angegeben, werden die bei uns gespeicherten Daten gelöscht, sobald sie für 
              ihre Zweckbestimmung nicht mehr erforderlich sind und der Löschung keine gesetzlichen 
              Aufbewahrungspflichten entgegenstehen.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;
